module.exports = {
  __init__: [ 'moveCanvas' ],
  moveCanvas: [ 'type', require('./MoveCanvas') ]
};


// WEBPACK FOOTER //
// ./~/diagram-js/lib/navigation/movecanvas/index.js